<template>
  <div class="Radio answerarea-item fontsize-16" :id="questionitem.innerid">
      <div class="topic-types">
        <p class="name" v-if="!isMaterialsItem"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="name" v-else><span>{{questioninfo.questionindex}}.{{questionitem.questionindex}}</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="title" v-html="questionitem.subject"></p>
      
        <div class="option-list">

            <div class="option-item" v-for="(options, index) in questionitem.optionslist" :key="index">
            
                
                <el-radio :label="options.optionsvalue" v-model="questionitem.uselanswer" :disabled="examstatus == 1">
                  <!--  -->
                  <span class="option-icon">
                    <template v-if="examstatus == 1 || isshow == 1">
                      <i class="el-icon-check" v-if="options.isrightanswer == 1 && questionitem.finalanswer == options.optionsvalue"></i>
                      
                      <i class="el-icon-close" v-else-if="questionitem.finalanswer == options.optionsvalue || questionitem.uselanswer == options.optionsvalue"></i>
                      <i class="el-icon-view" v-else style="visibility:hidden"></i>
                    </template>
                    <template v-else>
                      <i class="el-icon-view" style="visibility:hidden"></i>
                      <!-- end 占位用图标 -->
                    </template>
                    <!-- end 试卷提交状态下 显示正确/错误答案选项图标 -->

                    {{options.optionsvalue}}.</span>
                  <span class="option-text" v-html="options.optionsinfo"></span>
                </el-radio>
            </div>
        </div>
      </div>
      <div class="topic-types answer" v-if="examstatus == 1 || isshow == 1">
        <p>
          <span>本题得分：</span>
          <span class="fraction">{{questionitem.userscore}}分</span>
        </p>
        <p>
          <span>正确答案：</span>
          <span>{{questionitem.finalanswer}}</span>
        </p>
        <p>
          <span>答案解析：</span>
          <span v-html="questionitem.quesanalysis"></span>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Radio',
  props: ['questionitem', 'examstatus', 'isshow', 'isMaterialsItem', 'questioninfo'],  // 试题列表 试卷提交状态 是否显示正确答案
  data () {
    return {}
  },
  mounted () {},
  methods: {},
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.Radio {
  .option-list .option-item .option-text  {
      float: right;
      transform: translateY(-5px);
      -webkit-transform: translateY(-5px);
      -ms-transform: translateY(-5px);
      -moz-transform: translateY(-5px);
      -o-transform: translateY(-5px);
  }
  .AnswerArea .topic-types .option-list .option-item .el-radio .el-radio__inner {
    transform: translateY(-2px);
    -webkit-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
  }
  .topic-types .option-list i {
    padding-top: 4px !important;
  }
}
</style>